// src/pages/ConditionsGeneralesVente.jsx

function ConditionsGeneralesVente() {
  const tableStyle = {
    width: '100%',
    maxWidth: '760px',
    margin: '0 auto 28px',
    borderCollapse: 'collapse',
    fontFamily: 'Arial, sans-serif',
    fontSize: '14px',
  };

  const thTdStyle = {
    border: '2px solid #2b57ff',
    padding: '10px 12px',
    verticalAlign: 'middle',
  };

  const thStyle = {
    ...thTdStyle,
    fontWeight: '700',
    textAlign: 'center',
  };

  const firstColStyle = {
    ...thTdStyle,
    width: '45%',
  };

  const centerColStyle = {
    ...thTdStyle,
    width: '27.5%',
    textAlign: 'center',
    whiteSpace: 'nowrap',
  };

  const titleStyle = {
    color: '#0b3bd6',
    fontWeight: '700',
    textDecoration: 'underline',
    margin: '18px 0 10px',
    textAlign: 'center',
  };
  return (
    <div className="container py-4" style={{ color: '#000' }}>
      <h2 className="mb-5 mt-5 text-center text-primary">
        CONDITIONS GENERALES ET PARTICULIERES DE VENTE
      </h2>
      <p>
        La société KEPLER est une SAS euros dont le siège social se situe 12 rue Poncelet,
        75017 Paris et inscrite au registre du commerce et des sociétés de Paris sous le n° 804
        360 402.<br></br> La société KEPLER est immatriculée au registre des opérateurs de
        voyages et de séjours sous le n° IM075150004, elle a souscrit auprès de April
        Entreprise EST, 200 Avenue de Colmar, 67100 Strasbourg, un contrat d’assurance (n° GPH
        000392) qui couvre sa responsabilité civile professionnelle.
      </p>
      <br></br>
      <p>
        <p className="text-secondary">1 - Inscription et passation d’une commande :</p>
        Les présentes Conditions Générales de Vente (ci-après « CGV ») s’appliquent à toute
        commande de prestations touristiques effectuée sur le site internet
        www.keplertravel.com, entre KEPLER et toute personne physique majeure agissant en
        qualité de consommateur (ci-après « le Client »).
        <br></br> Toute commande implique l’acceptation sans réserve des présentes CGV.
      </p>
      <br></br>
      <p>
        Le Client effectue sa commande directement sur le site Kepler. Toute réservation est
        soumise à disponibilité au moment de la commande. La commande devient ferme et
        définitive après confirmation écrite de KEPLER et encaissement de l’acompte ou du
        paiement total
      </p>
      <p>
        <p className="text-secondary">2 - Capacité :</p>
        Le client reconnaît avoir la capacité de contracter aux conditions décrites, c&#39;est
        à dire être majeur tel que cela est défini par le pays d’accueil, être capable
        juridiquement de contracter et ne pas être sous tutelle ou curatelle. Le client garanti
        la véracité et l&#39;exactitude des informations fournies lors de la commande pour
        lui-même et pour l’ensemble des participants au voyage.
      </p>
      <br></br>
      <p>
        <p className="text-secondary">3 - Prix et règlement :</p>
        Tous les prix sont affichés en euros. Ces prix incluent les taxes et les surcharges
        carburant. Ces prix n’incluent pas les assurances voyages qui sont facultatives. Tarifs
        particuliers : Les tarifs faisant l&#39;objet de règles particulières, tels que les
        suppléments chambres individuelles et les réductions enfants sont fournis à titre
        indicatif. Si une modification devait affecter le montant de ces tarifs, le client en
        serait informé avant la confirmation de sa commande.
      </p>
      <br></br>
      <p>
        Conformément au Code du tourisme, le Client reconnaît avoir pris connaissance,
        préalablement à la commande, des informations relatives notamment : - aux
        caractéristiques essentielles des prestations, - aux prix, - aux formalités
        administratives et sanitaires, - aux conditions d’annulation et de modification, - à
        l’absence de droit de rétractation.
      </p>
      <br></br>
      <p>
        3.0 Révision des prix : <br></br>
        Le prix forfaitaire des voyages et séjours varie notamment selon la période
        d&#39;exécution du voyage, selon le nombre de participants ou selon la compagnie
        aérienne. Les prix sont des tarifs contractuels. Aucune contestation relative au prix
        du séjour ne pourra donc être prise en compte dès lors que la demande de réservation
        est effective.
      </p>
      <br></br>
      <p>
        Les prix indiqués ont été établis en fonction des conditions économiques en vigueur au
        moment où ils ont été communiqués à Kepler, par ses prestataires, par les voyagistes ou
        les compagnies aériennes. Ces prix peuvent être révisés, dans les conditions fixées par
        l’article L 221-12 du code du tourisme, tant à la hausse qu&#39;à la baisse, afin de
        tenir compte des variations : du coût des transports, lié notamment au carburant, des
        redevances et taxes afférentes aux prestations offertes telles que taxes
        d&#39;atterrissage et embarquement, débarquement dans les aéroports et des taux de
        change.
      </p>
      <br></br>
      <p>
        En cas de variation du montant des taxes et redevances passagers, celle-ci sera
        intégralement et immédiatement répercutée dans le prix de tous les produits à compter
        de sa date d&#39;application, y compris pour les clients déjà inscrits et ayant déjà
        réglé la prestation correspondante. Cependant aucune révision du prix ne pourra
        intervenir moins de 30 jours avant le départ. Des taxes locales supplémentaires peuvent
        être imposées par les autorités locales de certains pays. Dans ce cas, ces taxes sont à
        la charge de l&#39;acheteur et sont à régler sur place et en monnaie locale. Les prix
        ne comprennent pas les services antérieurs à l&#39;enregistrement à l&#39;aéroport et
        postérieurs au retour à l&#39;aéroport, les repas pris aux escales lors du transit
        éventuel entre deux vols, ainsi que les boissons et dépenses d&#39;ordre personnel.
      </p>
      <br></br>
      <p>
        3.1 Erreurs manifestes:<br></br>
        Malgré le soin apporté à la mise à jour des informations tarifaires, des erreurs
        manifestes de prix (prix dérisoire ou manifestement erroné au regard de la valeur
        réelle de la prestation) peuvent exceptionnellement survenir.<br></br>
        Conformément à l’article 1169 du Code civil et à la jurisprudence applicable, KEPLER se
        réserve le droit d’annuler toute réservation comportant une erreur manifeste de prix, y
        compris après confirmation de la commande.
      </p>
      <br></br>
      <p>
        Dans ce cas, le Client sera informé dans les meilleurs délais et se verra proposer, au
        choix :<br></br>
        <ul>
          <li> soit le maintien de la réservation au prix corrigé,</li>
          <li>
            {' '}
            soit l’annulation de la réservation avec remboursement intégral des sommes versées,
            sans que le Client puisse prétendre à une quelconque indemnisation.
          </li>
        </ul>
      </p>
      <br></br>
      <p>
        3.2 Conditions de règlement :<br></br>
        Un acompte de 40 % du montant total est exigé à la réservation.<br></br>
        Le solde doit être réglé au plus tard 45 jours avant le départ.<br></br>
        Pour toute réservation effectuée à moins de 45 jours du départ, le paiement intégral
        est exigé à la commande.
      </p>
      <br></br>
      <p>
        Les paiements s’effectuent par carte bancaire via un système de paiement sécurisé. En
        communiquant ses coordonnées bancaires, le Client autorise expressément KEPLER à
        procéder au prélèvement automatique du solde à la date d’échéance. Le solde sera
        prélevé automatiquement à date d’échéance du montant restant dû en utilisant
        l’empreinte de la carte bancaire ayant servie au règlement de l’acompte.
      </p>
      <br></br>
      <p>
        3.3 Divers<br></br>
        La communication d&#39;un numéro de carte de paiement n’est pas considérée comme
        libératoire des sommes dues tant que l&#39;accord du centre n&#39;est pas obtenu, à
        défaut de parfait paiement, KEPLER est en droit de considérer que le client a annulé sa
        réservation. Attention : Afin de minimiser les conséquences des fraudes aux cartes
        bancaires, KEPLER se réserve le droit d&#39;effectuer des vérifications et de demander
        au client de lui communiquer par tous moyens la preuve de son adresse, une copie recto
        verso de la carte bancaire servant au paiement, ainsi que celle d&#39;une pièce
        d&#39;identité du porteur de la carte bancaire et celle des passagers.
      </p>
      <br></br>
      <p>
        <p className="text-secondary">4 - Formalités :</p>
        4.1 Responsabilité du client <br></br>
        Chaque client est entièrement responsable de la validité, de la conformité et de la
        mise à jour de tous ses documents de voyage (passeport, carte d’identité, visa, etc.).{' '}
        <br></br>
        Les clients doivent vérifier avant leur départ les formalités applicables à leur
        situation personnelle : visas, autorisations d’entrée, documents d’identité, formalités
        douanières et sanitaires, y compris pour les pays de transit. <br></br>
        KEPLER ne procède à aucune vérification individuelle et ne pourra être tenue
        responsable en cas de refus d’embarquement, de transit ou d’entrée sur le territoire.
      </p>
      <br></br>
      <p>
        4.3 Documents obligatoires<br></br>
        Tous les voyageurs, quel que soit leur âge (bébés, enfants mineurs, etc.), doivent
        détenir une pièce d’identité individuelle portant leur nom (carte d’identité ou
        passeport selon la destination).<br></br>
        Les documents tels que les livrets de famille ou cartes de séjour ne permettent pas de
        franchir les frontières. Un visa peut être nécessaire selon la destination.
      </p>
      <br></br>
      <p>
        4.4 Vérification des documents<br></br>
        Les clients doivent vérifier la validité de leurs documents avant le départ et
        s’assurer que toutes les informations (nom, prénom, date de naissance, etc.) sont
        exactes.<br></br>
        Dès réception des billets ou bons de réservation, vérifier que les noms figurant sur
        les documents correspondent exactement à ceux de la pièce d’identité et du visa.
        <br></br>
        Certains pays exigent : Passeport valable plus de 6 mois après le retour Capacité à
        démontrer la possession d’un billet de retour Preuve de fonds suffisants pour le séjour
      </p>
      <br></br>
      <p>
        4.5 Coûts et frais<br></br>
        Tous les frais liés à l’obtention de documents de voyage, visas ou vaccins sont à la
        charge du client. En cas de refus d’embarquement ou de débarquement pour non-respect
        des formalités, aucun remboursement ne sera effectué, et tous les frais supplémentaires
        resteront à la charge du client (billets, amendes, etc.). Ressources utiles<br></br>
        Avant le départ, les clients sont invités à consulter les sites suivants pour vérifier
        les formalités administratives et sanitaires : www.diplomatie.gouv.fr<br></br>
        www.action-visas.com<br></br>
        www.travelsante.com<br></br>
      </p>
      <br></br>
      <p>
        Si le client se voit refuser l’embarquement ou le débarquement en raison de
        l’inobservation des formalités administratives et/ou sanitaires aucune somme ne pourra
        lui être remboursée et tous les éventuels frais supplémentaires (achat d’un billet
        d’avion, amendes etc…) resteront à sa charge.
      </p>
      <br></br>
      <p>
        <p className="text-secondary">5 - Réclamations :</p>
        Toute réclamation doit impérativement être adressée à KEPLER par lettre recommandée
        avec accusé de réception ou par email à l’adresse qualite@keplertravel.com, accompagnée
        de pièces justificatives dans les 15 jours suivant le retour de voyage.<br></br>
        Toute réclamation devra faire l’objet d’un signalement sur place auprès du représentant
        Kepler dont le numéro de téléphone est communiqué dans les documents de voyage, le
        client pourra aussi s’adresser à la réception de l’hôtel pour être mis en contact avec
        le représentant dans le but d’apporter une solution directement sur place.
        <br></br>
        <br></br>
        En cas de difficultés rencontrées lors des transports aériens assurés par les
        compagnies aériennes (retards, annulations, refus d’embarquement, pertes ou retards de
        bagages, etc.), toute réclamation doit être adressée directement par le Client à la
        compagnie aérienne concernée, conformément à la réglementation applicable.<br></br>
        <br></br>
        KEPLER recommande au Client de conserver l’ensemble des documents utiles au traitement
        de sa demande, notamment les cartes d’embarquement, étiquettes bagages et justificatifs
        de frais. Ces documents devront être transmis directement à la compagnie aérienne, les
        originaux pouvant être exigés par celle-ci.<br></br>
        <br></br>
        En cas de retard aérien ayant entraîné des frais supplémentaires (hébergement, repas,
        boissons, transports, etc.), la demande de remboursement ou d’indemnisation,
        accompagnée des justificatifs correspondants, doit être adressée exclusivement à la
        compagnie aérienne, dans les délais prévus par sa procédure, et dans la mesure du
        possible dans un délai de trente (30) jours suivant le retour.<br></br>
        KEPLER n’intervient pas dans le traitement de ces réclamations et ne saurait être tenue
        responsable des décisions prises par les compagnies aériennes.
        <br></br>
        <br></br>
        Les prestations non utilisées en raison de cette situation (première nuit, transferts)
        ne sont pas remboursables.
      </p>
      <br />
      <p>
        <p className="text-secondary">6 - Assurances : </p>
        Aucune assurance n&#39;est comprise dans les prix proposés par KEPLER. Dès lors, KEPLER
        recommande vivement la souscription d’une assurance couvrant notamment l’annulation,
        l’assistance et le rapatriement.
      </p>
      <br />
      <p>
        <p className="text-secondary">
          7 – Annulation / Modification à l’initiative du client :{' '}
        </p>
        Toute demande de modification ou d&#39;annulation doit être communiquée à KEPLER par
        email : reservations@keplertravel.com, ou par lettre recommandée avec accusé de
        réception à l&#39;adresse suivante : KEPLER - Service réservation – 12 rue Poncelet,
        75017 Paris La date de réception du courrier recommandé ou du mail sera la date retenue
        pour appliquer le barème de frais d&#39;annulation ou de modification.
        <br />
        <br />
        Une absence de présentation le jour du départ, ainsi que l’impossibilité d’effectuer le
        départ à la suite de la non-présentation de documents de voyages (passeport, visa,
        certificat de vaccination, etc.) constituent une annulation à 100% du montant du
        voyage. Il est précisé que si l’un des prestataires de Kepler applique des frais
        d&#39;annulation ou de modification supérieurs au barème qui figure ci-dessous, ce sont
        les frais d&#39;annulation ou de modification de ce prestataire qui seront applicables.
      </p>

      <br />
      <h3 style={titleStyle}>CONDITIONS D'ANNULATION & DE MODIFICATION MOYEN COURRIER</h3>

      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={thStyle}>Avant le départ</th>
            <th style={thStyle}>
              Frais d'annulation
              <br />
              Par personne
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={firstColStyle}>Plus de 60 jours</td>
            <td style={centerColStyle}>50%</td>
          </tr>
          <tr>
            <td style={firstColStyle}>Entre 59 jours et 30 jours</td>
            <td style={centerColStyle}>60%</td>
          </tr>
          <tr>
            <td style={firstColStyle}>Entre 29 jours et 15 jours</td>
            <td style={centerColStyle}>70%</td>
          </tr>
          <tr>
            <td style={firstColStyle}>Entre 14 jours et 8 jours</td>
            <td style={centerColStyle}>90%</td>
          </tr>
          <tr>
            <td style={firstColStyle}>Moins de 7 jours</td>
            <td style={centerColStyle}>100%</td>
          </tr>
        </tbody>
      </table>

      {/* ================= LONG COURRIER ================= */}
      <h3 style={titleStyle}>CONDITION D'ANNULATION & DE MODIFICATION LONG COURRIER</h3>

      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={thStyle}>Avant le départ</th>
            <th style={thStyle}>
              Frais d'annulation
              <br />
              Par personne
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={firstColStyle}>Plus de 60 jours</td>
            <td style={centerColStyle}>50%</td>
          </tr>
          <tr>
            <td style={firstColStyle}>Entre 59 jours et 30 jours</td>
            <td style={centerColStyle}>60%</td>
          </tr>
          <tr>
            <td style={firstColStyle}>Entre 29 jours et 15 jours</td>
            <td style={centerColStyle}>70%</td>
          </tr>
          <tr>
            <td style={firstColStyle}>Entre 14 jours et 8 jours</td>
            <td style={centerColStyle}>90%</td>
          </tr>
          <tr>
            <td style={firstColStyle}>Moins de 7 jours</td>
            <td style={centerColStyle}>100%</td>
          </tr>
        </tbody>
      </table>
      <br />
      <p>
        Toute modification concernant les participants (changement de nom, substitution, ajout
        ou retrait) doit être signalée et acceptée par Kepler avant le départ. <br />
        <br />
        Tout changement de nom doit faire l’objet d’une modification préalable auprès de
        Kepler, ce qui entraîne des frais de modification à la charge du client. <br />
        En cas de présentation à l’hôtel ou aux prestataires avec des noms différents de ceux
        déclarés, le client peut se voir refuser sa réservation, et l’hôtel ou Kepler sont en
        droit de réclamer des frais supplémentaires.
      </p>
      <br />
      <p>
        <p className="text-secondary">
          8 - Interruption de séjour / Non présentation au départ{' '}
        </p>
        En cas de non-présentation au départ frais de résolution s’appliquent tels qu’énoncés
        au paragraphe 8. <br />
        Le client ne pourra prétendre à aucun remboursement ni au versement d’aucune indemnité
        s’il interrompt son séjour et/ou ne consomme pas les prestations prévues et/ou modifie
        durant son séjour les prestations initialement prévues. <br />
        Si le client a souscrit une assurance optionnelle couvrant notamment l&#39;interruption
        de séjour, il devra se conformer aux directives de l’assurance figurant dans les
        conditions du contrat d&#39;assurance. <br />
        Sur les vols réguliers, tous les tronçons doivent être utilisés dans l’ordre faute de
        quoi la compagnie aérienne se réserve le droit de réajuster le tarif ou d&#39;annuler
        tous les tronçons de la chaîne de vols.
      </p>
      <br />
      <p>
        <p className="text-secondary">9 - Hébergement et prestations sur place : </p>
        Il est de règle en hôtellerie internationale de disposer de sa chambre à partir de 14
        heures quelle que soit l&#39;heure d&#39;arrivée du vol et de la libérer avant 12
        heures quel que soit l&#39;horaire du vol retour. En aucun cas, il ne pourra être
        dérogé à cette règle. <br />
        <br />
        9.1 Classification de l&#39;Hôtel : <br />
        Le nombre d&#39;étoiles attribuées à l’établissement hôtelier figurant dans les
        descriptifs correspond à une classification établie en référence à des normes locales
        du pays d&#39;accueil et qui peuvent donc différer des normes françaises et
        européennes. En outre les méthodes de classification des hôtels d’un pays à l’autre
        peuvent également varier. KEPLER ne saurait en aucun cas être tenu responsable de toute
        interprétation sur une éventuelle classification locale. <br />
        <br />
        9.2 Modification des hôtels, circuits, autotours, délogement hôtels : <br />
        Il peut arriver que KEPLER soit amené, pour des raisons indépendantes de sa volonté, à
        changer les hôtels ou les bateaux ou les compagnies aériennes mentionnés sans que cette
        mesure constitue une modification d&#39;un élément essentiel du voyage. Dans la mesure
        du possible, les clients seront avisés avant leur départ et KEPLER fournira un service
        dans la même catégorie que celui proposé initialement. De même, dans certains pays, le
        sens des circuits et des autotours pourra être modifié mais toutes les visites et
        étapes prévues seront respectées. Les fêtes tant civiles que religieuses, les grèves et
        les manifestations dans les pays visités ou tout autre cas de force majeure sont
        susceptibles d&#39;entraîner des modifications ou des annulations de visites ou
        excursions, sans que le client ne puisse prétendre à un remboursement <br />
        <br />
        9.3 Types de chambres : <br />
        Les chambres ou cabines individuelles comprennent un lit pour une personne. Prévues en
        nombre limité, elles font souvent l&#39;objet d&#39;un supplément. Les chambres doubles
        sont prévues, soit avec deux lits, soit, très rarement, avec un lit double. Les
        chambres triples et quadruples sont souvent des chambres doubles équipées de lits
        d&#39;appoint. <br />
        <br />
        9.4 Repas : <br />
        Le nombre des repas dépend du nombre de nuits passées à l&#39;hôtel. <br />
        - La demi-pension et la pension complète débutent avec le dîner de la première nuit et
        prend fin avec le petit déjeuner du dernier jour. La demi-pension comprend : un
        petit-déjeuner et un repas par jour (midi ou soir selon les hôtels). Que ce soit dans
        le cadre de la pension complète ou de la demi-pension, les boissons ne sont pas
        comprises, sauf exception dûment mentionnée dans le descriptif. <br />
        <br />
        Attention : selon les pays, les prestataires ne disposent pas toujours d&#39;eau
        courante potable. Les frais d&#39;achats de bouteilles d&#39;eau potable sont alors à
        la charge du client. <br />
        <br />
        9.5 Activités proposées lors du séjour : <br />
        Certaines activités proposées peuvent présenter des risques notamment pour les jeunes
        enfants. La responsabilité de KEPLER ne saurait être engagée en cas d&#39;incident ou
        d&#39;accident imputable à un manquement de vigilance de la part du client. Il peut
        advenir que certaines activités indiquées dans le descriptif soient supprimées par le
        prestataire local. La responsabilité de KEPLER ne saurait être engagée si ces activités
        sont supprimées en cas de force majeure, du fait imprévisible et insurmontable d&#39;un
        tiers étranger à la prestation ou du fait du client. <br />
        <br />
        L’hôtelier  se réserve le droit d’effectuer des travaux ,de réduire et/ou de
        réorganiser les services proposés dans son établissement (accès aux restaurants,
        activités sportives, piscine, infrastructures , animation, etc…), et de fermer une ou
        plusieurs sections du complexe hôtelier, en raisons de contraintes techniques ou
        opérationnelles et sans que la Responsabilité de Kepler ne soit engagée et sans que le
        client ne puisse prétendre à aucun remboursement ni au versement d’aucune indemnité.{' '}
        <br />
        <br />
        9.6 Locations de voiture : <br />
        Le temps de location correspond à 24 heures multiplié par le nombre de nuits effectuées
        pendant le séjour. A titre d’exemple, un autotour de 8 jours/7 nuits, correspondra à
        une location de véhicule valable 7x24 heures, à savoir du jour 1 (10 heures) au jour 8
        (10 heures). Si ce délai est dépassé, le loueur facturera en jour supplémentaire (à
        régler sur place par le client). Il arrive fréquemment qu’un supplément de prix soit
        prévu quand la voiture est retirée le soir. Les conditions des loueurs étant
        particulières, il convient de consulter KEPLER avant la réservation pour connaître les
        spécificités de chaque destination et pouvoir réserver en toute connaissance de cause.{' '}
        <br />
        <br />
        9.7 Perte et vol : <br />
        KEPLER conseille vivement à ses clients de n’emporter aucun objet de valeur pour
        limiter les risques en cas de perte ou de vol. Tous les effets personnels et objets de
        valeur (argent, bijoux, cartes de crédit, appareils électroniques etc.) restent sous la
        responsabilité des clients. Ces objets de valeur et effets personnels doivent être
        placés dans les coffres forts qui se trouvent dans les chambres d’hôtels ou doivent
        être confiés à la réception de l’hôtel. KEPLER ne peut être tenu pour responsable du
        vol ou de la perte des objets de valeur et/ou des effets personnels.
      </p>
      <br />
      <p>
        <p className="text-secondary">10 - Responsabilité de KEPLER :</p>
        10.1 Force majeure
        <br />
        KEPLER ne pourra être tenu pour responsable des cas fortuits, des cas de force majeure
        (notamment les grèves, les intempéries, les catastrophes naturelles ou sanitaires,
        l&#39;interruption des moyens de communications…) du fait des tiers, ou de la faute du
        client (présentation après l&#39;heure de convocation, non-respect des formalités
        administratives, douanières, de santé, non présentation à l’embarquement…).
        <br />
        <br />
        10.2 Aléas
        <br />
        Un client ne pourra en aucune manière engager la responsabilité de KEPLER dans
        l&#39;hypothèse de retards, de modifications d&#39;itinéraire de vol ou de changements
        d&#39;aéroport, notamment causés, en période de gros trafic, par des grèves des
        personnels des compagnies aériennes ou des aéroports, par de nombreuses rotations des
        appareils et les impératifs de sécurité, de même que tout retard dû aux conditions
        atmosphériques. Dans ces hypothèses, KEPLER ne sera tenue à aucune indemnisation à
        quelque titre que ce soit. De manière générale KEPLER conseille vivement à ses clients
        de prévoir un temps de connexion minimum de 3 heures en cas de pré ou post acheminement
        par leurs propres moyens pour l’aéroport et de réserver des titres de transport
        modifiables, échangeables ou remboursables, afin de limiter les éventuels frais à leur
        charge.
      </p>
      <br />
      <p>
        <p className="text-secondary">11 - Packages/forfaits touristiques :</p>
        11.1 Durée des Voyages :<br />
        Les durées de voyages et les prix sont calculés en fonction d&#39;un nombre de nuitées,
        et non de journées entières. La durée ou la nature des prestations terrestres peut être
        modifiée en raison d&#39;aléas dus au transport ou à des cas de force majeure, sans que
        le client puisse prétendre à remboursement ou indemnisation. Tout voyage interrompu ou
        abrégé du fait du client ne donnera lieu à aucun remboursement.
        <br />
        Le jour du départ à compter de l&#39;enregistrement et le jour du retour jusqu&#39;à
        l&#39;heure d&#39;arrivée sont inclus dans la durée des voyages. L&#39;arrivée le 1er
        jour peut être très tardive, voire dans la nuit, de même au retour, le transport peut
        avoir lieu tôt le matin, entraînant un départ du lieu de séjour dans le courant de la
        nuit. Si dans ces cas de figure, la première et/ou la dernière nuit se trouvaient
        écourtées, aucun remboursement ne pourrait avoir lieu.
        <br />
        Tout repas supplémentaire devant être fourni sera à payer sur place. Tout repas non
        pris ne sera pas remboursé.
        <br />
        <br />
        11.2 Dispositions applicables à certains circuits :<br />
        L&#39;exécution de certains circuits est soumise à la réunion d&#39;un nombre minimum
        de participants précisés dans le tableau des prix du circuit concerné. La mention «
        départ garanti à partir de X participants » confère à l’organisateur la faculté
        d’annuler le voyage lorsque ce seuil n’est pas atteint, conformément à l’article
        L211-14 I du Code du tourisme. Elle ne crée pas, en revanche, une obligation
        d’annulation, ni un droit automatique pour le voyageur à la résolution du contrat
        lorsque l’organisateur décide de maintenir le départ. Kepler reste seule décisionnaire
        pour la confirmation ou l’annulation d’une réservation, et se réserve le droit de
        modifier ou d’annuler un circuit en fonction des conditions opérationnelles ou des
        contraintes des prestataires. La confirmation ou l&#39;annulation d’un circuit
        intervient au plus tard 15 jours avant la date de départ. Le client ne pourra prétendre
        à aucune indemnité si l&#39;annulation du circuit intervient en raison d’un nombre
        insuffisant de participants au plus tard à 15 jours du départ.
        <br />
        Il appartient au voyageur de vérifier les conditions de partage ou de voyage avant la
        validation de sa réservation.
      </p>
      <br />
      <p>
        <p className="text-secondary">
          12 - Conditions particulières liées au transport aérien :{' '}
        </p>
        12.1 Conditions générales du transporteur aérien : <br />
        Les prestations de transport aérien incluses dans les voyages proposés par KEPLER sont
        assurées par des compagnies aériennes régulières ou à bas coût (low-cost),
        sélectionnées par KEPLER ou par ses prestataires. KEPLER agit en qualité d’organisateur
        de voyages et n’a pas la qualité de transporteur aérien. Les conditions de transport
        des passagers et des bagages sont régies par les conditions générales de la compagnie
        aérienne concernée, que le Client déclare connaître et accepter. <br />
        KEPLER affrète ou co-affrète des avions de compagnies aériennes pour être en mesure de
        proposer des voyages, séjours et circuits à ses clients. Si la responsabilité de KEPLER
        est mise en cause dans le cadre d’un transport aérien, les conditions générales du
        transporteur aérien, qui peuvent notamment comporter des clauses d’exclusion et/ou de
        limitation de responsabilité seront opposables au client <br /> <br />
        12.2 Aéroport ou gare de départ et d’arrivée : <br />
        Le client est informé que des changements d’aéroport ou de gare à l’aller et au retour
        peuvent se produire, notamment à Paris (entre l’aéroport d’Orly et de Roissy Charles de
        Gaulle), et que cela ne peut donner lieu à aucun dédommagement de quelque nature que ce
        soit. De même, le départ ou l’arrivée peut s’effectuer depuis la gare ferroviaire de la
        ville de départ ou d’arrivée. Le Client est tenu de respecter strictement les horaires
        de convocation, d’enregistrement et d’embarquement communiqués. Tout manquement à ces
        obligations pourra entraîner un refus d’embarquement sans possibilité de remboursement{' '}
        <br /> <br />
        12.3 Attribution des sièges : <br />
        KEPLER n’est pas en mesure de garantir que les clients qui voyagent ensemble seront
        assis dans l’avion les uns à côté des autres. Dès lors, aucune indemnité ne pourra être
        versée si les clients sont séparés au cours de leur trajet. <br /> <br />
        12.4 Vols opérés par des compagnies aériennes low-cost <br />
        Lorsque le transport aérien est assuré par une compagnie dite « low-cost », le Client
        est informé que les prestations incluses sont strictement limitées au transport aérien
        entre les aéroports mentionnés. <br /> Sauf indication contraire, ne sont pas inclus
        dans le prix du billet : <br />{' '}
        <ul>
          <li> les bagages en soute,</li>
          <li>
            {' '}
            les bagages cabine au-delà de la franchise minimale éventuellement autorisée,
          </li>{' '}
          <li> le choix du siège,</li>
          <li> les repas et boissons à bord,</li>{' '}
          <li>
            {' '}
            ainsi que toute autre prestation optionnelle proposée par la compagnie aérienne.
          </li>{' '}
        </ul>
        Il appartient au Client de vérifier les conditions spécifiques applicables
        (enregistrement en ligne, horaires limites, poids et dimensions des bagages, frais
        éventuels). KEPLER ne saurait être tenue responsable des contraintes propres aux
        compagnies low-cost, notamment en cas de non-respect par le Client des règles imposées
        par la compagnie aérienne. <br /> <br />
        12.5 Incidents aériens et frais supplémentaires <br />
        En cas de retards, annulations, refus d’embarquement, surréservations ou perturbations
        du trafic aérien, les mesures d’assistance, de prise en charge ou d’indemnisation
        relèvent exclusivement de la responsabilité de la compagnie aérienne, conformément à la
        réglementation applicable. Les frais éventuellement engagés par le Client à cette
        occasion (hébergement, repas, transports, etc.) sont soumis aux conditions de la
        compagnie aérienne et ne sauraient engager la responsabilité de KEPLER, sauf
        disposition légale impérative contraire. <br />
        <br />
        12.6 Non-présentation au départ : <br />
        En cas de non-présentation au départ frais de résolution s’appliquent tels qu’énoncés
        au paragraphe 7.
        <br />
        Tout voyage interrompu, abrégé ou toute prestation non consommée du fait de
        l&#39;acheteur ne donnera droit à aucun remboursement.
        <br />
        Si le client a souscrit une assurance optionnelle couvrant notamment l&#39;interruption
        de séjour, il devra se conformer aux modalités d&#39;annulation figurant dans les
        conditions du contrat d&#39;assurance.
        <br />
        Sur les vols réguliers, tous les tronçons doivent être utilisés faute de quoi la
        compagnie aérienne se réserve le droit de réajuster le tarif ou d&#39;annuler les
        places.
        <br />
        <br />
        12.7 Prestations sur place :<br />
        Certains tarifs sont sujets à présentation de prestations terrestres obligatoires lors
        de l&#39;enregistrement. KEPLER décline toute responsabilité si un passager se voyait
        refuser l&#39;embarquement pour non-respect de cette disposition.
        <br />
        <br />
        12.8 Animaux :<br />
        Chaque compagnie a sa propre politique en matière d&#39;animaux. En principe, ils sont
        interdits sur les vols charters. Sous réserve de formalités en règle et sur accord
        préalable de la compagnie aérienne, les animaux familiers peuvent être admis en soute
        sur certains vols réguliers. La demande doit être faite directement auprès de la
        compagnie sur laquelle le client a prévu de voyager.
        <br />
        <br />
        12.9 Repas spéciaux :<br />
        Généralement, les vols charters ne proposent pas de repas spéciaux. En revanche, sur
        les vols réguliers, KEPLER peut interroger les compagnies aériennes qui répondent
        généralement dans un délai de 48 heures sur la possibilité de servir un repas spécial.
        KEPLER ne peut être tenu pour responsable de l’impossibilité de servir un repas
        spécial.
        <br />
        <br />
        12.10 Bagages :<br />
        Les règles relatives aux bagages cabine et en soute — notamment le nombre, les
        dimensions, le poids, les conditions de transport et les éventuels frais — sont fixées
        par chaque compagnie aérienne et peuvent être modifiées sans préavis. Il appartient au
        Client de se renseigner avant le départ sur les franchises applicables auprès de la
        compagnie aérienne concernée et de s’y conformer strictement, en particulier concernant
        le poids et, le cas échéant, le nombre maximum de bagages autorisés sans frais
        supplémentaires.
        <br />
        KEPLER ne pourra en aucun cas être tenue responsable des frais additionnels, refus
        d’embarquement ou pénalités résultant du non- respect par le Client des règles imposées
        par la compagnie aérienne.
        <br />
        KEPLER recommande de ne pas dépasser le poids autorisé et de prévoir, dans la mesure du
        possible, un seul bagage par personne. Les franchises sont généralement appliquées
        individuellement. Tout supplément de bagages imposé par le transporteur sera à la
        charge exclusive du Client.
        <br />
        <br />
        En cas de perte de bagage ou de dommage causé à un bagage lors du transport aérien, le
        client doit signaler immédiatement, à son arrivée dans l’aéroport, cette perte ou ce
        dommage au transporteur aérien. Le client doit conserver une copie de sa déclaration de
        perte ou d’avarie, sa carte d’embarquement, des étiquettes bagage et de tous documents
        utiles. Ces documents devront être envoyés, le cas échéant, à la compagnie d’assurance
        auprès de laquelle le client aura souscrit une assurance voyage. En toute hypothèse les
        pertes, vols ou dégâts causés aux biens suivants ne sont pas indemnisables : bijoux,
        argent, perles, pierres dures, montres, objets d’art, objets précieux ou de valeurs,
        appareils électroniques (appareils photo, caméras, téléphones, tablettes, etc…)
        passeports, pièces d’identité.
        <br />
        Il est fortement recommandé de conserver sur soi pendant toute la durée du voyage les
        biens indispensables tels que les médicaments ou les lunettes de vue.
      </p>
      <br />
      <p>
        <p className="text-secondary">13 - Photos, illustrations, vidéos :</p>
        13.1 Photos, illustrations et vidéo sur le site internet kepler.com :<br />
        KEPLER s&#39;efforce d&#39;illustrer ses propositions de photos ou illustrations
        donnant un aperçu réaliste des services proposés. Il est toutefois précisé que les
        photos et illustrations figurant dans le descriptif sont simplement illustratives des
        services. Ces photos n’ont pas de caractère contractuel
        <br />
        Les clients qui séjournent à l’hôtel, sont susceptibles d’être filmés et/ou
        photographiés pendant leur séjour au cours de leurs activités et/ou de leurs loisirs
        (sports, jeux etc…). En participant à ces activités et/ou à ces loisirs, les clients
        autorisent KEPLER à diffuser et/ou à reproduire leur image dans le monde entier et pour
        la durée du droit à l’image. KEPLER s’engage à limiter la diffusion et/ou la
        reproduction de ces images aux réseaux sociaux et au site internet kepler.com Les
        clients ont cependant la possibilité s’ils le souhaitent de demander durant leur séjour
        aux représentants ou à leur retour, que leur image ne soit ni diffusée ni reproduite.
      </p>
      <br />
      <p>
        <p className="text-secondary">14 - Dispositions diverses : </p>
        Dans le cas où l&#39;une des dispositions des conditions de vente serait déclarée nulle
        ou sans effet, cette disposition serait réputée non écrite, sans que cela n&#39;affecte
        la validité des autres dispositions sauf si la disposition déclarée nulle ou sans effet
        était essentielle et déterminante. Dans ce dernier cas, les parties négocieront son
        remplacement par une disposition ayant un effet économique équivalent.
      </p>
      <br />
      <p>
        <p className="text-secondary">15 - Droit applicable : </p>
        Les conditions de vente sont soumises au droit français. Tout litige relatif à leur
        interprétation et/ou à leur exécution relève des tribunaux de Paris.
        <br />
        <br />
        15 - CNIL :<br />
        15.1. Informatique et libertés :<br />
        Les données à caractère personnel recueillies sur le site KEPLER sont collectées et
        traitées conformément aux dispositions de la loi n° 78-17 modifiée du 6 janvier 1978
        relative à l’informatique, aux fichiers et aux libertés (dite « Loi Informatique et
        Libertés »). Vous disposez d’un droit d’accès, d’opposition, de modification, de
        rectification et de suppression des données qui vous concernent en écrivant par lettre
        recommandée avec accusé de réception à KEPLER 12 rue Poncelet, 75017 Paris.
        <br />
        <br />
        15.2. Cookies KEPLER :<br />
        Lors de la consultation du site KEPLER, des cookies sont déposés sur votre ordinateur,
        votre mobile ou votre tablette. Ces cookies nous permettent d’enregistrer vos
        préférences et de personnaliser les offres que nous vous proposons. Vous pouvez
        désactiver les cookies en suivant les instructions comme suit :<br />
        1/ si vous utilisez le navigateur Internet Explorer Dans Internet Explorer, cliquez sur
        le bouton Outils, puis sur Options Internet. Sous l&#39;onglet Général, sous Historique
        de navigation, cliquez sur Paramètres. Cliquez sur le bouton Afficher les fichiers.
        <br />
        Cliquez sur l&#39;en-tête de colonne Nom pour trier tous les fichiers dans l&#39;ordre
        alphabétique, puis parcourez la liste jusqu&#39;à ce que vous voyiez des fichiers
        commençant par le préfixe « Cookie ». (Tous les cookies possèdent ce préfixe et
        contiennent habituellement le nom du site Web qui a créé le cookie).
        <br />
        Sélectionnez-le ou les cookies comprenant le nom « KEPLER » et supprimez-les. Fermez la
        fenêtre qui contient la liste des fichiers, puis cliquez deux fois sur OK pour
        retourner dans Internet Explorer.
        <br />
        2/ si vous utilisez le navigateur Firefox
        <br />
        Allez dans l&#39;onglet Outils du navigateur puis sélectionnez le menu Options
        <br />
        Dans la fenêtre qui s&#39;affiche, choisissez Vie privée et cliquez sur Affichez les
        cookies
        <br />
        Repérez les fichiers qui contiennent le nom « KEPLER » Sélectionnez-les et
        supprimez-les.
        <br />
        3/ si vous utilisez le navigateur Safari
        <br />
        Dans votre navigateur, choisissez le menu Édition &gt; Préférences.
        <br />
        Cliquez sur Sécurité.
        <br />
        Cliquez sur Afficher les cookies.
        <br />
        Sélectionnez les cookies qui contiennent le nom « KEPLER » et cliquez sur Effacer ou
        sur Tout effacer.
        <br />
        Après avoir supprimé les cookies, cliquez sur Terminé.
        <br />
        4/ si vous utilisez le navigateur Google Chrome
        <br />
        Cliquez sur l&#39;icône du menu Outils.
        <br />
        Sélectionnez Options.
        <br />
        Cliquez sur l&#39;onglet Options avancées et accédez à la section
        &quot;Confidentialité&quot;.
        <br />
        Cliquez sur le bouton Afficher les cookies.
        <br />
        Repérez les fichiers qui contiennent le nom « KEPLER » Sélectionnez-les et
        supprimez-les.
        <br />
        Cliquez sur Fermer pour revenir à votre navigateur
        <br />
        <br />
        15.3. Cookies Tiers :<br />
        Lorsque vous visitez notre site Internet, certains cookies ne seront pas enregistrés
        par nous mais par des tiers. Ces cookies dépendent principalement des régies
        publicitaires. Par exemple, si vous cliquez sur des publicités de tiers qui
        apparaissent sur notre site Internet (c&#39;est-à-dire qui font la promotion d&#39;un
        produit que nous ne vendons pas nous-mêmes), ces tiers enregistrent des cookies sur
        votre appareil. Nous suggérons par conséquent de regarder les sites Internet de ces
        tiers pour plus d&#39;informations sur les cookies qu&#39;ils enregistrent et comment
        vous pouvez les gérer.
        <br />
        Le refus de ces cookies publicitaires n&#39;a pas d&#39;impact sur l&#39;utilisation de
        notre site. Cependant le fait de refuser les cookies publicitaires n&#39;entraînera pas
        l&#39;arrêt de la publicité sur notre site ou sur Internet. Cela aura seulement pour
        effet d&#39;afficher une publicité qui ne tiendra pas compte de vos centres
        d&#39;intérêt ou de vos préférences.
      </p>
      <br />
      <p>
        <p className="text-secondary">16 - Absence de droit de rétractation :</p>
        Conformément à ce que prévoit l’article L 121-20-4, 2° du code de la consommation, le
        droit de rétractation d’une durée de 7 jours prévu aux articles L121.20 et suivants de
        ce même code n’est pas applicable aux ventes de voyage. Dès lors toutes les ventes de
        voyages, séjours, ou circuits sont soumises aux conditions d’annulation et de
        modification fixées par les présentes conditions générales.
        <br />
        Extraits du code du tourisme
        <br />
        Conformément à l&#39;article R 211-12 du code du tourisme, les articles R211-3 à
        R211-11 du code du tourisme sont ci-dessous reproduits :Il est toutefois précisé que
        ces dispositions ne sont pas applicables lorsque les prestations vendues n&#39;entrent
        pas
        <br />
        <br />
        dans un forfait touristique tel que défini à l&#39;article 2 de ladite loi. Ces
        dispositions ne sont notamment pas applicables lors de la vente de titres de transport
        seuls, de locations de voiture seules, de prestations d&#39;hébergement seules.
        <br />
        Les dispositions précitées sont les suivantes :<br />
        Article R211-3
        <br />
        Sous réserve des exclusions prévues aux troisième et quatrième alinéa de l&#39;article
        L. 211-7, toute offre et toute vente de prestations de voyages ou de séjours donnent
        lieu à la remise de documents appropriés qui répondent aux règles définies par la
        présente section. En cas de vente de titres de transport aérien ou de titres de
        transport sur ligne régulière non accompagnée de prestations liées à ces transports, le
        vendeur délivre à l&#39;acheteur un ou plusieurs billets de passage pour la totalité du
        voyage, émis par le transporteur ou sous sa responsabilité. Dans le cas de transport à
        la demande, le nom et l&#39;adresse du transporteur, pour le compte duquel les billets
        sont émis, doivent être mentionnés.
        <br />
        La facturation séparée des divers éléments d&#39;un même forfait touristique ne
        soustrait pas le vendeur aux obligations qui lui sont faites par les dispositions
        réglementaires de la présente section.
        <br />
        <br />
        Article R211-3-1
        <br />
        L&#39;échange d&#39;informations précontractuelles ou la mise à disposition des
        conditions contractuelles est effectué par écrit. Ils peuvent se faire par voie
        électronique dans les conditions de validité et d&#39;exercice prévues aux articles
        1369-1 à 1369-11 du code civil. Sont mentionnés le nom ou la raison sociale et
        l&#39;adresse du vendeur ainsi que l&#39;indication de son immatriculation au registre
        prévu au a de l&#39;article L. 141-3 ou, le cas échéant, le nom, l&#39;adresse et
        l&#39;indication de l&#39;immatriculation de la fédération ou de l&#39;union
        mentionnées au deuxième alinéa de l&#39;article R. 211-2.
        <br />
        <br />
        Article R211-4
        <br />
        Préalablement à la conclusion du contrat, le vendeur doit communiquer au consommateur
        les informations sur les prix, les dates et les autres éléments constitutifs des
        prestations fournies à l&#39;occasion du voyage ou du séjour tels que : <br />
        1° La destination, les moyens, les caractéristiques et les catégories de transports
        utilisés.
        <br />
        2° Le mode d&#39;hébergement, sa situation, son niveau de confort et ses principales
        caractéristiques, son homologation et son classement touristique correspondant à la
        réglementation ou aux usages du pays d&#39;accueil.
        <br />
        3° Les prestations de restauration proposées.
        <br />
        4° La description de l&#39;itinéraire lorsqu&#39;il s&#39;agit d&#39;un circuit.
        <br />
        5° Les formalités administratives et sanitaires à accomplir par les nationaux ou par
        les ressortissants d&#39;un autre Etat membre de l&#39;Union européenne ou d&#39;un
        Etat partie à l&#39;accord sur l&#39;Espace économique européen en cas, notamment, de
        franchissement des frontières ainsi que leurs délais d&#39;accomplissement.
        <br />
        6° Les visites, excursions et les autres services inclus dans le forfait ou
        éventuellement disponibles moyennant un supplément de prix.
        <br />
        7° La taille minimale ou maximale du groupe permettant la réalisation du voyage ou du
        séjour ainsi que, si la réalisation du voyage ou du séjour est subordonnée à un nombre
        minimal de participants, la date limite d&#39;information du consommateur en cas
        d&#39;annulation du voyage ou du séjour. Cette date ne peut être fixée à moins de vingt
        et un jours avant le départ.
        <br />
        8° Le montant ou le pourcentage du prix à verser à titre d&#39;acompte à la conclusion
        du contrat ainsi que le calendrier de paiement du solde.
        <br />
        9° Les modalités de révision des prix telles que prévues par le contrat en application
        de l&#39;article R. 211-8.
        <br />
        10° Les conditions d&#39;annulation de nature contractuelle.
        <br />
        11° Les conditions d&#39;annulation définies aux articles R. 211-9, R. 211-10 et R.
        211-11.
        <br />
        12° L&#39;information concernant la souscription facultative d&#39;un contrat
        d&#39;assurance couvrant les conséquences de certains cas d&#39;annulation ou d&#39;un
        contrat d&#39;assistance couvrant certains risques particuliers, notamment les frais de
        rapatriement en cas d&#39;accident ou de maladie.
        <br />
        13° Lorsque le contrat comporte des prestations de transport aérien, l&#39;information,
        pour chaque tronçon de vol, prévue aux articles R. 211-15 à R. 211-18.
        <br />
        <br />
        Article R211-5
        <br />
        L&#39;information préalable faite au consommateur engage le vendeur, à moins que dans
        celle-ci le vendeur ne se soit réservé expressément le droit d&#39;en modifier certains
        éléments. Le vendeur doit, dans ce cas, indiquer clairement dans quelle mesure cette
        modification peut intervenir et sur quels éléments. En tout état de cause, les
        modifications apportées à l&#39;information préalable doivent être communiquées au
        consommateur avant la conclusion du contrat.
        <br />
        <br />
        Article R211-6
        <br />
        Le contrat conclu entre le vendeur et l&#39;acheteur doit être écrit, établi en double
        exemplaire dont l&#39;un est remis à l&#39;acheteur, et signé par les deux parties.
        Lorsque le contrat est conclu par voie électronique, il est fait application des
        articles 1369-1 à 1369-11 du code civil. Le contrat doit comporter les clauses
        suivantes : <br />
        1° Le nom et l&#39;adresse du vendeur, de son garant et de son assureur ainsi que le
        nom et l&#39;adresse de l&#39;organisateur.
        <br />
        2° La destination ou les destinations du voyage et, en cas de séjour fractionné, les
        différentes périodes et leurs dates.
        <br />
        3° Les moyens, les caractéristiques et les catégories des transports utilisés, les
        dates et lieux de départ et de retour.
        <br />
        4° Le mode d&#39;hébergement, sa situation, son niveau de confort et ses principales
        caractéristiques et son classement touristique en vertu des réglementations ou des
        usages du pays d&#39;accueil.
        <br />
        5° Les prestations de restauration proposées.
        <br />
        6° L&#39;itinéraire lorsqu&#39;il s&#39;agit d&#39;un circuit.
        <br />
        7° Les visites, les excursions ou autres services inclus dans le prix total du voyage
        ou du séjour.
        <br />
        8° Le prix total des prestations facturées ainsi que l&#39;indication de toute révision
        éventuelle de cette facturation en vertu des dispositions de l&#39;article R. 211-8.
        <br />
        9° L&#39;indication, s&#39;il y a lieu, des redevances ou taxes afférentes à certains
        services telles que taxes d&#39;atterrissage, de débarquement ou d&#39;embarquement
        dans les ports et aéroports, taxes de séjour lorsqu&#39;elles ne sont pas incluses dans
        le prix de la ou des prestations fournies.
        <br />
        10° Le calendrier et les modalités de paiement du prix ; le dernier versement effectué
        par l&#39;acheteur ne peut être inférieur à 40 % du prix du voyage ou du séjour et doit
        être effectué lors de la remise des documents permettant de réaliser le voyage ou le
        séjour.
        <br />
        11° Les conditions particulières demandées par l&#39;acheteur et acceptées par le
        vendeur.
        <br />
        12° Les modalités selon lesquelles l&#39;acheteur peut saisir le vendeur d&#39;une
        réclamation pour inexécution ou mauvaise exécution du contrat, réclamation qui doit
        être adressée dans les meilleurs délais, par tout moyen permettant d&#39;en obtenir un
        accusé de réception au vendeur, et, le cas échéant, signalée par écrit, à
        l&#39;organisateur du voyage et au prestataire de services concernés.
        <br />
        13° La date limite d&#39;information de l&#39;acheteur en cas d&#39;annulation du
        voyage ou du séjour par le vendeur dans le cas où la réalisation du voyage ou du séjour
        est liée à un nombre minimal de participants, conformément aux dispositions du 7° de
        l&#39;article R. 211-4. 14° Les conditions d&#39;annulation de nature contractuelle.
        <br />
        15° Les conditions d&#39;annulation prévues aux articles R. 211-9, R. 211-10 et R.
        211-11.
        <br />
        16° Les précisions concernant les risques couverts et le montant des garanties au titre
        du contrat d&#39;assurance couvrant les conséquences de la responsabilité civile
        professionnelle du vendeur.
        <br />
        17° Les indications concernant le contrat d&#39;assurance couvrant les conséquences de
        certains cas d&#39;annulation souscrit par l&#39;acheteur (numéro de police et nom de
        l&#39;assureur) ainsi que celles concernant le contrat d&#39;assistance couvrant
        certains risques particuliers, notamment les frais de rapatriement en cas
        d&#39;accident ou de maladie, dans ce cas, le vendeur doit remettre à l&#39;acheteur un
        document précisant au minimum les risques couverts et les risques exclus.
        <br />
        18° La date limite d&#39;information du vendeur en cas de cession du contrat par
        l&#39;acheteur.
        <br />
        19° L&#39;engagement de fournir à l&#39;acheteur, au moins sept jours avant la date
        prévue pour son départ, les informations suivantes :<br />
        a) Le nom, l&#39;adresse et le numéro de téléphone de la représentation locale du
        vendeur ou, à défaut, les noms, adresses et numéros de téléphone des organismes locaux
        susceptibles d&#39;aider le consommateur en cas de difficulté ou, à défaut, le numéro
        d&#39;appel permettant d&#39;établir de toute urgence un contact avec le vendeur.
        <br />
        b) Pour les voyages et séjours de mineurs à l&#39;étranger, un numéro de téléphone et
        une adresse permettant d&#39;établir un contact direct avec l&#39;enfant ou le
        responsable sur place de son séjour.
        <br />
        20° La clause de résiliation et de remboursement sans pénalités des sommes versées par
        l&#39;acheteur en cas de non-respect de l&#39;obligation d&#39;information prévue au
        13° de l&#39;article R. 211-4.
        <br />
        21° L&#39;engagement de fournir à l&#39;acheteur, en temps voulu avant le début du
        voyage ou du séjour, les heures de départ et d&#39;arrivée.
        <br />
        <br />
        Article R211-7 L&#39;acheteur peut céder son contrat à un cessionnaire qui remplit les
        mêmes conditions que lui pour effectuer le voyage ou le séjour, tant que ce contrat
        n&#39;a produit aucun effet.
        <br />
        Sauf stipulation plus favorable au cédant, celui-ci est tenu d&#39;informer le vendeur
        de sa décision par tout moyen permettant d&#39;en obtenir un accusé de réception au
        plus tard sept jours avant le début du voyage. Lorsqu&#39;il s&#39;agit d&#39;une
        croisière, ce délai est porté à quinze jours. Cette cession n&#39;est soumise, en aucun
        cas, à une autorisation préalable du vendeur.
        <br />
        <br />
        Article R211-8 Lorsque le contrat comporte une possibilité expresse de révision du
        prix, dans les limites prévues à l&#39;article L. 211-12, il doit mentionner les
        modalités précises de calcul, tant à la hausse qu&#39;à la baisse, des variations des
        prix, et notamment le montant des frais de transport et taxes y afférentes, la ou les
        devises qui peuvent avoir une incidence sur le prix du voyage ou du séjour, la part du
        prix à laquelle s&#39;applique la variation, le cours de la ou des devises retenu comme
        référence lors de l&#39;établissement du prix figurant au contrat.
        <br />
        <br />
        Article R211-9
        <br />
        Lorsque, avant le départ de l&#39;acheteur, le vendeur se trouve contraint
        d&#39;apporter une modification à l&#39;un des éléments essentiels du contrat telle
        qu&#39;une hausse significative du prix et lorsqu&#39;il méconnaît l&#39;obligation
        d&#39;information mentionnée au 13° de l&#39;article R. 211-4, l&#39;acheteur peut,
        sans préjuger des recours en réparation pour dommages éventuellement subis, et après en
        avoir été informé par le vendeur par tout moyen permettant d&#39;en obtenir un accusé
        de réception :<br />
        <br />
        Soit résilier son contrat et obtenir sans pénalité le remboursement immédiat des sommes
        versées.
        <br />
        Soit accepter la modification ou le voyage de substitution proposé par le vendeur. Un
        avenant au contrat précisant les modifications apportées est alors signé par les
        parties, toute diminution de prix vient en déduction des sommes restant éventuellement
        dues par l&#39;acheteur et, si le paiement déjà effectué par ce dernier excède le prix
        de la prestation modifiée, le trop-perçu doit lui être restitué avant la date de son
        départ.
        <br />
        <br />
        Article R211-10
        <br />
        Dans le cas prévu à l&#39;article L. 211-14, lorsque, avant le départ de
        l&#39;acheteur, le vendeur annule le voyage ou le séjour, il doit informer
        l&#39;acheteur par tout moyen permettant d&#39;en obtenir un accusé de réception.
        L&#39;acheteur, sans préjuger des recours en réparation des dommages éventuellement
        subis, obtient auprès du vendeur le remboursement immédiat et sans pénalité des sommes
        versées. L&#39;acheteur reçoit, dans ce cas, une indemnité au moins égale à la pénalité
        qu&#39;il aurait supportée si l&#39;annulation était intervenue de son fait à cette
        date.
        <br />
        Les dispositions du présent article ne font en aucun cas obstacle à la conclusion
        d&#39;un accord amiable ayant pour objet l&#39;acceptation, par l&#39;acheteur,
        d&#39;un voyage ou séjour de substitution proposé par le vendeur.
        <br />
        <br />
        Article R211-11
        <br />
        Lorsque, après le départ de l&#39;acheteur, le vendeur se trouve dans
        l&#39;impossibilité de fournir une part prépondérante des services prévus au contrat
        représentant un pourcentage non négligeable du prix honoré par l&#39;acheteur, le
        vendeur doit immédiatement prendre les dispositions suivantes sans préjuger des recours
        en réparation pour dommages éventuellement subis : Soit proposer des prestations en
        remplacement des prestations prévues en supportant éventuellement tout supplément de
        prix et, si les prestations acceptées par l&#39;acheteur sont de qualité inférieure, le
        vendeur doit lui rembourser, dès son retour, la différence de prix.
        <br />
        Soit, s&#39;il ne peut proposer aucune prestation de remplacement ou si celles-ci sont
        refusées par l&#39;acheteur pour des motifs valables, fournir à l&#39;acheteur, sans
        supplément de prix, des titres de transport pour assurer son retour dans des conditions
        pouvant être jugées équivalentes vers le lieu de départ ou vers un autre lieu accepté
        par les deux parties.
        <br />
        Les dispositions du présent article sont applicables en cas de non-respect de
        l&#39;obligation prévue au 13° de l&#39;article R. 211-4.
        <br />
        <br />
        Article R211-12
        <br />
        Les dispositions des articles R. 211-3 à R. 211-11 doivent obligatoirement être
        reproduites sur les brochures et les contrats de voyages proposés par les personnes
        mentionnées à l&#39;article L. 211-1.
      </p>
      <br />
      <p>
        CHARTE DE LA MEDIATION TOURISME ET VOYAGE www.mtv.travel <br /> <br />
        CHAPITRE I – LE MEDIATEUR Article 1.1 Désignation Le Médiateur est désigné, après
        consultation des associations de consommateurs*, par les adhérents institutionnels au
        sens du 6.2.1 des statuts, pour une durée de trois (3) ans renouvelable. Il exerce
        conformément aux dispositions du Code de la Consommation. Article 1.2 Compétences Le
        Médiateur est désigné compte tenu de ses compétences qui lui permettent de rendre des
        avis en équité et en droit. Article 1.3 Indépendance Le Médiateur ne doit pas être lié
        à un fournisseur de services liés aux transport, hébergement, loisirs, voyage et
        tourisme par un contrat de travail, ni détenir des actions de l&#39;un des fournisseurs
        de services liés aux transport, hébergement, voyage et tourisme, ni intervenir comme
        consultant pour un des fournisseurs de services liés aux transport, hébergement, voyage
        et tourisme, ni avoir de liens avec une association de consommateurs. Le Médiateur
        exerce sa mission en toute indépendance et ne reçoit aucune directive de qui que ce
        soit. Le Médiateur ne peut être révoqué pendant la durée de son mandat. 3 Il disposera
        des moyens nécessaires pour remplir sa mission. Article 1.4 Confidentialité Le
        Médiateur est soumis à une obligation de confidentialité. Le nom des parties, le
        contenu du dossier et les faits dont il a eu connaissance dans l’exercice de sa mission
        demeurent confidentiels. Aucun des avis qu&#39;il est amené à rendre ne peut être porté
        à la connaissance de tiers sauf accord de toutes les parties. <br /> <br />
        CHAPITRE II – DOMAINE D’APPLICATION DE LA MEDIATION Article 2.1 Champ d&#39;application
        La Médiation s&#39;applique àtous les litiges opposant un fournisseur de services liés
        aux transport, hébergement, voyage, loisir et tourisme, membre de l&#39;une des
        organisations signataires ou adhérant directement à la présente Charte, à l&#39;un de
        ses Clients, (ci-après désigné Client) découlant de contrats de vente ou de service
        conclus entre le professionnel et le consommateur Article 2.2 Saisine relative à un non
        adhérent Dans le cas d’un professionnel non adhérent à la MTV, le Médiateur pourra
        proposer, au dit professionnel l’accès à la Médiation Tourisme et Voyage, aux
        conditions et tarifs mentionnées dans un document, qui lui sera communiqué
        systématiquement en cas de saisine. <br /> <br />
        CHAPITRE III – FONCTIONNEMENT DELA MEDIATION Article 3.1 Saisine préalable du
        fournisseur deservices de transport, voyage et tourisme Le recours au Médiateur
        n&#39;est recevable que si le client a préalablement saisi le service interne à
        l&#39;entreprise compétent pour le règlement des litiges (services chargés de la
        clientèle, des réclamations, de la qualité, services après-vente …). En cas de
        multiplicité d’opérateurs (ex : forfait/package), la saisine d’un des d’intervenants,
        mis en cause est suffisante. Le fournisseur de services liés aux transport,
        hébergement, loisirs, voyage et tourisme communique au Client la possibilité de
        recourir à la « Médiation Tourisme et Voyage ». 4 Cette communication se traduit par
        l’inclusion, sur son site internet, dans ses conditions de vente et contrats ainsi que
        dans le dernier courrier du professionnel au Client indiquant son refus ou son
        désaccord, d’une mention indiquant l’existence du Médiateur et de sa faculté d’y
        recourir. En cas de saisine de l’entreprise et sans réponse de sa part dans un délai de
        60 jours, le consommateur pourra saisir le médiateur Le Médiateur décide de la
        recevabilité des différends qui lui sont soumis. Il est recommandé que le Médiateur
        réoriente le dossier qui lui a été adressé prématurément, vers le service traitant les
        réclamations, chez le professionnel mis en cause. S’il se déclare incompétent, le
        Médiateur doit informer le Client par écrit. Article 3.2 Procédure de saisine Le
        Client, de façon intuitu personae ou représenté (lorsqu’il a explicitement manifesté sa
        volonté de saisir le Médiateur) ou le fournisseur de services liés aux transport,
        hébergement, loisirs, voyage et tourisme saisit le Médiateur au moyen d&#39;un
        formulaire mis à disposition par le Médiateur, accompagné d&#39;une copie des documents
        en sa possession, soit directement en ligne, soit par voie postale. Le Médiateur accuse
        réception de ce dossier et demande à l&#39;autre partie de lui transmettre les éléments
        en sa possession et de lui exposer sa position dans le délai de 30 jours. A défaut de
        réponse dans le délai indiqué, le Médiateur commence à instruire le dossier sur la
        seule base des éléments en sa possession. <br />
        Les échanges entre le Médiateur et les parties se font par écrit sauf si le Médiateur
        souhaite entendre personnellement les deux parties. Article 3.3 Avis rendu par le
        Médiateur Une fois l&#39;instruction du dossier terminée, et dans un délai maximum de
        90 jours à compter de la recevabilité, le Médiateur rend un avis en équité et en droit.
        Toutefois, après en avoir informé les parties, ce délai pourra être rallongé en
        fonction de la nature, de la complexité, ou du caractère exceptionnel du litige. Un
        exemplaire de l’avis est adressé au Client et un autre exemplaire au fournisseur de
        services concerné. Chaque partie à la Médiation est libre de suivre ou de ne pas suivre
        l’avis rendu par le Médiateur, et en informe l’autre partie ainsi que le Médiateur avec
        ses motivations. 5 Si l’avis a été accepté par les parties, le Médiateur a vocation à
        en être informé par ces dernières notamment lors d’éventuelles difficultés dans la mise
        en œuvre de cet avis. <br /> <br /> CHAPITRE IV – EFFETS ET FIN DE LA MEDIATION Article
        4.1 Prescription Le Médiateur doit être saisi dans l’année suivant la 1ere réclamation
        faite auprès du professionnel mis en cause. Article 4.2 Action en justice Le Médiateur
        ne peut pas être saisi si une action en justice a été engagée par le fournisseur de
        services de transport aérien, hébergement, loisirs, voyage et tourisme ou le Client,.
        Toute action en justice introduite par l&#39;une des parties contre l’autre partie, en
        cours de Médiation met fin à celle-ci. Le Médiateur s&#39;interdit de représenter ou de
        conseiller l&#39;une des parties dans une procédure relative au litige faisant
        l&#39;objet de la médiation. Article 4.3 Confidentialité. L’avis du Médiateur est
        confidentiel; les parties ne peuvent pas, sauf accord entre elles, le produire dans le
        cadre d&#39;une instance judiciaire. <br /> <br /> CHAPITRE V – SUIVI DE LA MEDIATION
        Article 5.1 Comité de suivi de la Médiation Tourisme et Voyage Afin de permettre un bon
        niveau d&#39;information, le comité de suivi de la Médiation Tourisme et Voyage se
        réunira au moins une fois par an sauf circonstances exceptionnelles, ou plus à
        l&#39;initiative du Médiateur. Ce comité est composé de représentants de l&#39;Etat,
        des associations de consommateurs *, des signataires de la présente Charte et du
        Médiateur. Article 5.2 Rapport annuel du Médiateur 6 Le Médiateur établit un rapport
        annuel qui est rendu public et diffusé sur son site internet. Ce rapport comprend
        notamment une analyse des saisines (nombre total, nombre de saisines rejetées, nombre
        d’avis favorables au professionnel ou au consommateur, …) et un récapitulatif des
        principaux litiges traités dans l’année. En outre, à partir du traitement des dossiers
        individuels, le Médiateur peut formuler des propositions d’amélioration afin de
        prévenir le renouvellement de certains litiges répétitifs ou significatifs et
        contribuer à améliorer la qualité de service des secteurs concernés. Ces
        recommandations générales, dont il suit la mise en œuvre, sont incluses dans le rapport
        annuel du Médiateur. A l&#39;exception du pourcentage d&#39;avis suivis par les
        fournisseurs de services de transport aérien, voyage et tourisme, le rapport ne
        contient aucun nom des parties à la Médiation ni aucun élément permettant
        d&#39;identifier l&#39;une de ces parties. <br /> CHAPITRE VI – PORTEE DE LA CHARTE
        Tout consommateur et tout fournisseur de services liés aux transport, hébergement,
        loisirs, voyage et tourisme, ayant recours au Médiateur désigné conformément à la
        présente Charte, s&#39;engagent à respecter la présente Charte en toutes ses
        dispositions. Ce dispositif peut recevoir l&#39;adhésion de nouveaux membres. La liste
        récapitulative, à jour, des signataires, figure sur le site internet de la MTV. <br />{' '}
        <br /> Annotations: *Au sens de la présente charte, le terme «associations de
        consommateurs» comprend toutes les associations de consommateurs agrées ne siégeant pas
        auprès de la commission d’évaluation et de contrôle de la médiation.
      </p>
    </div>
  );
}
export default ConditionsGeneralesVente;
